/**
 * Server action for setting user locale
 */

'use server'

import { Locale } from '@/types/i18n'
import { setUserLocale as setLocale } from '@/lib/util/locale'

export async function setUserLocale(locale: Locale) {
  await setLocale(locale)
}
